import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { CoacheesEditObserversController } from 'presentation/app-sidebar/sidebar-coachees/coachees-edit-observers/coachees-edit-observers.controller';
import { CoacheesEditObserversStore } from 'presentation/app-sidebar/sidebar-coachees/coachees-edit-observers/coachees-edit-observers.store';

@Component({
	selector: 'spr-coachees-edit-observers',
	templateUrl: './coachees-edit-observers.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [CoacheesEditObserversStore, CoacheesEditObserversController],
})
export class CoacheesEditObserversComponent {
	public BASE_I18N_KEY = CoacheesEditObserversController.BASE_I18N_KEY;

	constructor(
		dialogConfig: DynamicDialogConfig,
		private _dialogRef: DynamicDialogRef,
		public controller: CoacheesEditObserversController
	) {
		controller.updateCoacheeId(dialogConfig.data.coacheeId);
	}

	public onUpdateClick(): void {
		this.controller.updateObservers().subscribe(() => this._dialogRef.close());
	}

	public onObserversIdChange(observersId: string[]): void {
		this.controller.updateObserversId(observersId);
	}
}
